import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { AddRounded, CloseRounded } from "@mui/icons-material";
import { setPidTabsSuccess } from "../../../core/events/pidEvents";
import { PID_URL } from "../../../utils/routes";
import { useHistory, useLocation } from "react-router-dom";
import { setPidTabsLocalStorage } from "../../../core/storage/localStorage";

function PIDTabs() {
  const history = useHistory();
  const theme = useTheme();
  const { tabs } = useSelector((state) => state.pid);
  const location = useLocation();
  const tabId = new URLSearchParams(location.search).get("tabId");
  const dispatch = useDispatch();

  const handleCloseTab = (event, id) => {
    event.stopPropagation();
    const newTabs = tabs.filter((tab) => tab.id !== id);
    setPidTabsLocalStorage(newTabs);
    dispatch(setPidTabsSuccess(newTabs));
    if (newTabs.length === 0) {
      history.push(PID_URL);
    } else {
      const newTab = newTabs[newTabs.length - 1];
      let queryParams = new URLSearchParams();
      queryParams.set("tabId", newTab.id);
      queryParams.set("fileId", newTab.file.id);
      history.push(`${location.pathname}?${queryParams.toString()}`);
    }
  };

  const handleTabClick = (tab) => {
    let queryParams = new URLSearchParams();
    queryParams.set("tabId", tab.id);
    queryParams.set("fileId", tab.file.id);
    history.push(`${location.pathname}?${queryParams.toString()}`);
  };

  const handleAddTab = () => {
    history.push(PID_URL);
  };

  return (
    <Box
      display={"flex"}
      alignItems={"center"}
      gap={1}
      py={1}
      px={2}
      bgcolor={(theme) => theme.palette.background.dark}>
      {tabs.map((tab) => {
        const isActive = tab.id === tabId;
        return (
          <Box
            key={tab.id}
            display={"flex"}
            alignItems={"center"}
            gap={1}
            sx={{
              background: isActive
                ? theme.palette.primary.lightBg
                : "transparent",
              p: 0.5,
              cursor: "pointer",
              borderRadius: 1,
              "&:hover": { backgroundColor: "action.hover" },
            }}
            onClick={() => handleTabClick(tab)}>
            <Typography
              variant="body2"
              sx={{ maxWidth: 150 }}
              noWrap
              textOverflow={"ellipsis"}
              overflow={"hidden"}>
              {tab.file.name}
            </Typography>
            <IconButton
              size="small"
              onClick={(event) => handleCloseTab(event, tab.id)}>
              <CloseRounded sx={{ fontSize: 16 }} />
            </IconButton>
          </Box>
        );
      })}
      <IconButton size="small" onClick={handleAddTab}>
        <AddRounded sx={{ fontSize: 16 }} />
      </IconButton>
    </Box>
  );
}

export default PIDTabs;
